var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"adminEntityList"},[(_vm.columns)?_c('tr',_vm._l((_vm.columns),function(column,i){return _c('th',{key:i},[_vm._v(_vm._s(column))])}),0):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }